import i18nHelper from './i18n-helper'
export default class AddressTypeHelper {
    static addressTypeDict = {
        WE: 'delivery.address.Title',
        AG: 'company.title',
        ZU: 'addressBuyer.component.forwardingAgent',
        RG: 'payer',
        CRR: 'deliveryDetails.page.carier'
    }

    static returnReceiptAddressTypeDict = {
        WE: 'return.details.page.title.returned.by',
        RG: 'return.details.page.title.credit.to'
    }

    static addressTypeMessage = {
        WE: this.getTypeMessage(
            'delivery.address.Title',
            'addressBuyer.component.deliveryAddressInfo'
        ),
        AG: this.getTypeMessage(
            'company.title',
            'addressBuyer.component.companyInfo'
        ),
        ZU: this.getTypeMessage(
            'addressBuyer.component.forwardingAgent',
            'addressBuyer.component.forwardingAgentInfo'
        ),
        CRR: this.getTypeMessage(
            'deliveryDetails.page.carier',
            'addressBuyer.component.carrierInfo'
        ),
        RG: this.getTypeMessage('payer', 'addressBuyer.component.payerInfo')
    }

    static getTypeMessage(titleKey, messageKey) {
        const titleValue = i18nHelper.getI18nMessage(titleKey)
        const messageValue = i18nHelper.getI18nMessage(messageKey)
        return `<strong>${titleValue}:</strong> ${messageValue}`
    }

    static getAddressTypeTag(addressType) {
        return i18nHelper.getI18nMessage(this.addressTypeDict[addressType])
    }

    static getReturnReceiptAddressTypeTag(addressType) {
        return i18nHelper.getI18nMessage(
            this.returnReceiptAddressTypeDict[addressType]
        )
    }

    static getAddressFromPartnerAddress(address) {
        return {
            addressType: address.addressType,
            partnerNo: address.partnerNo,
            name1: address.name1,
            name2: address.name2,
            houseNo: address.hosueNo,
            address1: address.address1,
            address4: address.address4,
            city: address.city, 
            postalDetails: `${address.stateName}, ${address.postalCode}`,
            fullAddress: [
                address.hosueNo,
                address.address1,
                address.address4,
                address.city,
                address.stateName,
                address.postalCode,
                address.countryName,
                address.country
            ].filter(Boolean).join(', '),
            country: address.countryName,
            countryCode: address.country,
            nameCo: address.nameCo
        }
    }

    static getCarrierInfo(carrier) {
        return {
            addressType: 'CRR',
            id: carrier.carrierId,
            name: carrier.carrierName,
            trackingNo: carrier.trackingNo,
            trackingUrl: carrier.trackingUrl
        }
    }

    static getAddressFromInternationalAddress(
        internationalAddresses,
        addresses
    ) {
        const partnerAddressList = []
        for (const internationalAddress of internationalAddresses) {
            if (internationalAddress.formattedAddress) {
                const partner = {}
                const partnerAddress = addresses.find(
                    (address) =>
                        address.addressType === internationalAddress.addressType
                )
                const calculateInternationalAddress =
                    internationalAddress.hasOwnProperty('streetName') &&
                    internationalAddress.hasOwnProperty('streetNumber')
                        ? `${internationalAddress.streetName}, ${internationalAddress.streetNumber}`
                        : internationalAddress.streetName
                if (partnerAddress) {
                    ;(partner.address = calculateInternationalAddress
                        ? calculateInternationalAddress
                        : partnerAddress.address),
                        (partner.addressType = internationalAddress.addressType
                            ? internationalAddress.addressType
                            : partnerAddress.addressType),
                        (partner.city = internationalAddress.town
                            ? internationalAddress.town
                            : partnerAddress.city),
                        (partner.country = partnerAddress.country),
                        (partner.countryCode = partnerAddress.countryCode),
                        (partner.fullAddress =
                            internationalAddress.formattedAddress),
                        (partner.name = internationalAddress.companyName
                            ? internationalAddress.companyName
                            : partnerAddress.name),
                        (partner.partnerNo = partnerAddress.partnerNo),
                        (partner.postalDetails = partnerAddress.postalDetails)
                } else {
                    ;(partner.address = calculateInternationalAddress
                        ? calculateInternationalAddress
                        : ''),
                        (partner.addressType = internationalAddress.addressType
                            ? internationalAddress.addressType
                            : ''),
                        (partner.city = internationalAddress.town
                            ? internationalAddress.town
                            : ''),
                        (partner.country = ''),
                        (partner.countryCode = ''),
                        (partner.fullAddress =
                            internationalAddress.formattedAddress),
                        (partner.name = internationalAddress.companyName
                            ? internationalAddress.companyName
                            : ''),
                        (partner.partnerNo = internationalAddress.partnerNo),
                        (partner.postalDetails =
                            internationalAddress.postalCode)
                }

                partnerAddressList.push(partner)
            }
        }
        return partnerAddressList
    }
    static formatAddressInfoMessage(tabs) {
        let addressTypeMessages = []
        tabs.forEach((tab) =>
            addressTypeMessages.push(this.addressTypeMessage[tab.addressType])
        )
        return addressTypeMessages.join(`\n`)
    }

    static sortTabs(tabs) {
        let list = []
        Object.entries(this.addressTypeDict).forEach((key) => {
            var tab = tabs.find((x) => x.addressType === key[0])
            if (tab) {
                list.push(tab)
            }
        })
        return list
    }

    static sortReturnReceiptTabs(tabs) {
        let list = []
        Object.entries(this.returnReceiptAddressTypeDict).forEach((key) => {
            var tab = tabs.find((x) => x.addressType === key[0])
            if (tab) {
                list.push(tab)
            }
        })
        return list
    }
}
